var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
export class StageTypeInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get stage() {
        return this.parent;
    }
    get app() {
        return this.stage.app;
    }
    get isEditStage() {
        return this.app.appInfo.isAppInEditBuild;
    }
    get isAbfragerStage() {
        if (runtime.isBrowserRuntime && !!this.app.question) {
            if (this.app.question.questionLayout.isAbfragerLayout) {
                return true;
            }
            return false;
        }
        if (!!this.app.topic && this.app.topic.packages_fallback.includes('abfrager') && !this.app.topic.packages_fallback.includes('draft')) {
            return true;
        }
        return false;
    }
    get isDraftStage() {
        return !this.isAbfragerStage;
    }
    get isRunStage() {
        return !!this.isEditStage;
    }
    get isAbfragerRunStage() {
        return this.isRunStage && this.isAbfragerStage;
    }
    get isDraftRunStage() {
        return this.isRunStage && this.isDraftStage;
    }
}
__decorate([
    computed // to avoid rerender AppStageRun
], StageTypeInfo.prototype, "isAbfragerStage", null);
